var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBsc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 28C21.732 28 28 21.732 28 14C28 6.26801 21.732 0 14 0C6.26801 0 0 6.26801 0 14C0 21.732 6.26801 28 14 28Z",
    fill: "#17181D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.69517 14.0001L7.70527 17.702L10.8508 19.553V21.7203L5.8644 18.7958V12.9176L7.69517 14.0001ZM7.69517 10.2982V12.4554L5.86328 11.3717V9.21451L7.69517 8.13086L9.53604 9.21451L7.69517 10.2982ZM12.1644 9.21451L13.9963 8.13086L15.8372 9.21451L13.9963 10.2982L12.1644 9.21451Z",
    fill: "#F1B90C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.01953 16.9347V14.7674L10.8514 15.8511V18.0083L9.01953 16.9347ZM12.165 20.3293L13.9969 21.4129L15.8378 20.3293V22.4865L13.9969 23.5701L12.165 22.4865V20.3293ZM18.465 9.21451L20.2969 8.13086L22.1378 9.21451V11.3717L20.2969 12.4554V10.2982L18.465 9.21451ZM20.2969 17.702L20.307 14.0001L22.1389 12.9164V18.7946L17.1525 21.7192V19.5519L20.2969 17.702Z",
    fill: "#F1B90C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9823 16.9349L17.1504 18.0084V15.8512L18.9823 14.7676V16.9349Z",
    fill: "#F1B90C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9833 11.0651L18.9934 13.2324L15.8389 15.0834V18.7943L14.007 19.8678L12.1751 18.7943V15.0834L9.02065 13.2324V11.0651L10.8604 9.98145L13.9958 11.8414L17.1503 9.98145L18.9912 11.0651H18.9833ZM9.01953 7.3643L13.9969 4.42969L18.9833 7.3643L17.1514 8.44796L13.9969 6.58802L10.8514 8.44796L9.01953 7.3643Z",
    fill: "#F1B90C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBsc);
export default __webpack_public_path__ + "static/media/bsc.54d76ddd0d3d1112fd14fdcfae344536.svg";
export { ForwardRef as ReactComponent };